import type { Event } from '@sentry/react';
import axios from 'axios';

function beforeSendError(event: Event): null | Event {
  const error = event.exception?.values?.[0];
  const isBuggyBrowser = navigator.userAgent?.includes('Chrome/102');
  const isEvaluatorError =
    error?.type === 'SyntaxError' ||
    error?.type === 'ReferenceError' ||
    error?.type === 'TypeError';

  const isTokenError =
    (axios.isAxiosError(error) && error.response?.status === 401) ||
    error?.value?.includes('fail with status code 401');

  const isSideEffectError =
    error?.type === 'EvalError' &&
    error?.value?.includes('Possible side-effect in debug-evaluate');

  const isIgnoredError =
    isSideEffectError || isEvaluatorError || isTokenError || isBuggyBrowser;

  if (isIgnoredError) {
    return null;
  }

  return event;
}

export default beforeSendError;
